import {SET_SERVER_ERROR_STATUS} from '../actions/actionTypes';

const initialState = {
    serverErrorStatus: null
};

export default (state = initialState, {type, ...payload}) => {
    switch (type) {
        case SET_SERVER_ERROR_STATUS: {
            const {serverErrorStatus} = payload;
            return {...state, serverErrorStatus};
        }

        default: {
            return state;
        }
    }
};
